import { render, staticRenderFns } from "./FixedCollection.vue?vue&type=template&id=7bcd549e"
import script from "./FixedCollection.vue?vue&type=script&lang=js"
export * from "./FixedCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports